import React from 'react';
import PropTypes from 'prop-types';
import mustache from 'mustache';
import handlebars from 'handlebars/dist/handlebars.min';

export default class PluginItemView extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        projectId: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        updateItem: PropTypes.func.isRequired,
        reportEvent: PropTypes.func.isRequired,
        refreshQueues: PropTypes.func.isRequired
    };

    static defaultProps = {
        configuration: null
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderHtml() {
        let createdAtDate = new Date(this.props.item.createdAt);
        let updatedAtDate = new Date(this.props.item.updatedAt);

        // Replace dates with human readable format
        let data = Object.assign({}, this.props.item, {
            createdAt: createdAtDate.toLocaleString(),
            updatedAt: updatedAtDate.toLocaleString()
        });

        switch (this.props.configuration.templateType) {
            case 'mustache':
                return mustache.render(this.props.configuration.template, data);
            case 'handlebars':
                return handlebars.compile(this.props.configuration.template)(data);
            default:
                return '';
        }
    }

    render() {
        if (!this.props.configuration || !this.props.configuration.template || !this.props.configuration.templateType) {
            return <div>Error: template was not configured</div>;
        }
        return (
            <div dangerouslySetInnerHTML={{__html: this.renderHtml()}}/>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/plugins/htmlTemplatePlugin/PluginItemView.js